const PERMISSION_EDIT = 'edit_document'
const PERMISSION_REMOVE = 'remove_content'

export class LibraryPermissionValidator {
  constructor(permissions) {
    if (Array.isArray(permissions)) {
      this.permissions = permissions
      return
    }
    this.permissions = []
  }
  hasPermission(permission) {
    return this.permissions.includes(permission)
  }
  canRemove() {
    return this.hasPermission(PERMISSION_REMOVE)
  }
  canEdit() {
    return this.hasPermission(PERMISSION_EDIT)
  }
}
